<template>
  <div
    class="offcanvas offcanvas-end"
    id="OffcanvasForm"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ type === 'CREATE'? $t('Create Branch'): $t('Edit Branch')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom mb-3 px-3 py-2">
        <i class="fa-solid fa-circle-info me-2" />
        {{ $t('Branch Information') }}
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-12">
            <label
              for="code"
              class="form-label"
            >
              {{ $t('Branch Code') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm">
              <input
                id="code"
                type="text"
                v-model.trim="v$.form.code.$model"
                class="form-control shadow-none"
                :placeholder="$t('Enter branch code') + '...'"
              >
              <div v-for="error of v$.form.code.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <label
              for="name"
              class="form-label"
            >
              {{ $t('Branch Name') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm">
              <input
                id="name"
                type="text"
                v-model.trim="v$.form.name.$model"
                class="form-control shadow-none"
                :placeholder="$t('Enter branch name') + '...'"
              >
              <div v-for="error of v$.form.name.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <label class="form-label" for="flexSwitchCheckIsMain">
              {{ $t('Is Main Branch (HQ)') }}
            </label>
            <div class="form-check form-switch">
              <input
                class="form-check-input shadow-none"
                type="checkbox" id="flexSwitchCheckIsMain"
                v-model.trim="v$.form.is_main.$model"
              >
              <label class="form-check-label" for="flexSwitchCheckIsMain">
                {{ $t('Set as headquarters') }}
              </label>
            </div>
          </div>
          <div class="col-12">
            <label class="form-label" for="flexSwitchCheckStatus">
              {{ $t('Status') }}
            </label>
            <div class="form-check form-switch">
              <input
                class="form-check-input shadow-none"
                type="checkbox" id="flexSwitchCheckStatus"
                v-model.trim="v$.form.is_active.$model"
              >
              <label class="form-check-label" for="flexSwitchCheckStatus">
                {{ $t('Active') }}
              </label>
            </div>
          </div>
          <div class="col-12">
            <label
              for="telephone1"
              class="form-label"
            >
              {{ $t('Telephone') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="telephone1"
                type="tel"
                v-model.trim="v$.form.telephone1.$model"
                class="form-control shadow-none"
                :placeholder="$t('Enter telephone') + '...'"
              >
              <div v-for="error of v$.form.telephone1.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <label
              for="address"
              class="form-label"
            >
              {{ $t('Address') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="address"
                type="text"
                v-model.trim="v$.form.address.$model"
                class="form-control shadow-none"
                :placeholder="$t('Enter address') + '...'"
              >
              <div v-for="error of v$.form.address.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12" >
            <label for="postal_code" class="form-label">
              {{ $t('Zipcode') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="postal_code"
                type="text"
                v-model.trim="v$.form.postal_code.$model"
                class="form-control shadow-none"
                :placeholder="$t('Enter zipcode') + '...'"
              >
              <div v-for="error of v$.form.postal_code.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <label
              class="form-label"
            >
              {{ $t('Sub District') }}
            </label>
            <select2
              v-model="v$.form.sub_district.$model"
              :options="districts"
              :settings="select2FormAddress.setting"
              @select="selectAddresses"
            />
          </div>
          <div class="col-12">
            <label
              class="form-label"
            >
              {{ $t('District') }}
            </label>
            <select2
              v-model="v$.form.district.$model"
              :options="amphoes"
              :settings="select2FormAddress.setting"
              @select="selectAddresses"
            />
          </div>
          <div class="col-12">
            <label
              class="form-label"
            >
              {{ $t('Province') }}
            </label>
            <select2
              v-model="v$.form.province.$model"
              :options="provinces"
              :settings="select2FormAddress.setting"
              @select="selectAddresses"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading && hasPermission"
    >
      <ladda
        text="Save"
        v-if="type === 'CREATE'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleCreate"
      />
      <ladda
        text="Save"
        v-if="type === 'EDIT'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleEdit"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import { Branches } from '@/services/endpoint/branches.service';
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';
import signature  from '@/services/signature';
import { searchAddressByZipcode } from 'thai-address-database';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    id: {
      type: Number,
      default: 0
    },
  },
  data() {
    let vm = this;
    return {
      select2FormAddress: {
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      loading: true,
      hasPermission: false,
      loadingSave: false,
      form: {
        code: '',
        name: '',
        is_main: false,
        is_active: true,
        telephone1: '',
        address: '',
        postal_code: '',
        sub_district: '0',
        district: '0',
        province: '0'
      }
    }
  },
  components: {
    PlaceholderContent,
    Ladda,
    AccessDenied,
    Select2
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getCreateData() {
      await Branches.getCreate().then(res => {
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    async getUpdateData() {
      await Branches.getUpdate(this.id).then(res => {
        let vm = this;
        this.form.code = res.data.data.code;
        this.form.name = res.data.data.name;
        this.form.is_main = res.data.data.main;
        this.form.is_active = res.data.data.active;
        this.form.telephone1 = res.data.data.telephone1;
        this.form.address = res.data.data.address;
        this.form.postal_code = res.data.data.postal_code || '';
        setTimeout(() => {
          this.form.sub_district = res.data.data.sub_district || 0;
          this.form.district = res.data.data.district || 0;
          this.form.province = res.data.data.province || 0;
        }, 1);
        this.hasPermission = true;
      }).catch(err => {
			  throw err;
      });
    },
    setParamsBeforeSendCreate() {
      let params = _.clone(this.form);
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
        if (
          (key == 'address' ||
          key == 'postal_code' ||
          key == 'sub_district' ||
          key == 'district' ||
          key == 'province') && value == '0'
        ) {
          delete params[key];
        }
      });
    },
    setParamsBeforeSendUpdate() {
      let params = _.cloneDeep(this.form);
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
        if (
          (key == 'address' ||
          key == 'postal_code' ||
          key == 'sub_district' ||
          key == 'district' ||
          key == 'province') && value == '0'
        ) {
          delete params[key];
        }
      });
    },
    async handleEdit() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await Branches.update(this.id, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Branch!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(this.$t(err?.response?.data?.message));
        }
        this.loadingSave = false;
      });
    },
    async handleCreate() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      this.loadingSave = false;
      await Branches.create(this.setParamsBeforeSendCreate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Save Branch!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        // โควตาสาขาเต็ม — ข้อความจาก server เป็นภาษาอังกฤษและไม่มี key แปล
        // ถ้าปล่อยตกไป $t() ข้างล่างลูกค้าจะเห็นประโยคอังกฤษดิบ ๆ ที่เอาไปทำอะไรต่อไม่ได้
        // ขึ้นตัวเลขจริงจาก server แทน (ใช้ 3/3) จะได้รู้ว่าต้องทำอะไรต่อ
        const res = err?.response;
        // API ยุบ ERROR_BRANCH_LIMIT_REACHED รวมเป็น ERROR_PLAN_LIMIT_REACHED + limit_code (ของเดิมรับไว้ช่วง deploy ไม่พร้อมกัน)
        const isBranchLimit = res?.data?.code === 'ERROR_BRANCH_LIMIT_REACHED'
          || (res?.data?.code === 'ERROR_PLAN_LIMIT_REACHED' && res?.data?.limit_code === 'limit_branches');
        if (res?.status === 403 && isBranchLimit) {
          this.$toast.warn(
            "<B>" + this.$t('Branch limit reached') + "</B>\n"
            + this.$t('Contact support to add more branches')
            + ' (' + res.data.used + '/' + res.data.limit + ')'
          );
          this.loadingSave = false;
          return;
        }

        if (err?.response?.data?.message) {
          this.$toast.warn(this.$t(err?.response?.data?.message));
        }
        this.loadingSave = false;
      });
    },
    selectAddresses({ id, text, module }) {
      if (module == 'sub_district') {
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.district == id);
          this.form.district = address.amphoe;
          this.form.province = address.province;
          this.form.postal_code = address.zipcode;
        }
      }

      if (module == 'district') {
        this.form.sub_district = '0';
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.amphoe == id);
          this.form.province = address.province;
          this.form.postal_code = address.zipcode;
        }
      }

      if (module == 'province') {
        this.form.sub_district = '0';
        this.form.district = '0';
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.province == id);
          this.form.postal_code = address.zipcode;
        }
      }
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        if (this.type === 'CREATE') await this.getCreateData();
        if (this.type === 'EDIT') await this.getUpdateData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.offcanvasFroms.open = false;
    });
  },
  computed: {
    addresses() {
      return searchAddressByZipcode(this.form.postal_code, 100);
    },
    districts() {
      if (!this.addresses.find((addresse) => addresse.district == this.form.sub_district)) {
        this.form.sub_district ='0';
      }
      return [
        {
          id: '0',
          text: this.$t('Select')+'...',
          module: 'sub_district'
        }
      ].concat([...new Set(this.addresses.map(item => item.district))].map(item => { return { id: item, text: item, module: 'sub_district' } }));
    },
    amphoes() {
      if (!this.addresses.find((addresse) => addresse.amphoe == this.form.district)) {
        this.form.district ='0';
      }
      return [
        {
          id: '0',
          text: this.$t('Select')+'...',
          module: 'district'
        }
      ].concat([...new Set(this.addresses.map(item => item.amphoe))].map(item => { return { id: item, text: item, module: 'district' } }));
    },
    provinces() {
      if (!this.addresses.find((addresse) => addresse.province == this.form.province)) {
        this.form.province ='0';
      }
      return [{ id: '0', text: this.$t('Select')+'...', module: 'province' }].concat([...new Set(this.addresses.map(item => item.province))].map(item => { return { id: item, text: item, module: 'province' } }));
    },
  }
}
</script>
